import { lenderStore } from '@/models/stores/index';
import type { Lender } from '@/models/types';

const useLenders = (): { lenders: Lender[] } => {
  const lenders = lenderStore.all;

  return { lenders };
};

export default useLenders;
